/**
 * MobileHeader - Header mobile com logo e notificações
 *
 * Header sticky transparente para dispositivos móveis com:
 * - Logo à esquerda
 * - Sino de notificações à direita
 *
 * @example
 * <MobileHeader />
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { NotificationDropdown } from './NotificationDropdown';
import logoAzul from '@/assets/logo-azul-sem-descricao.png';

interface MobileHeaderProps {
  /** Classes adicionais */
  className?: string;
  /** Mostrar notificações (default: true) */
  showNotifications?: boolean;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({
  className,
  showNotifications = true,
}) => {
  return (
    <header
      className={cn(
        'h-14 px-4 flex items-center justify-between',
        'bg-transparent',
        'sticky top-0 z-40',
        'md:hidden',
        className
      )}
    >
      {/* Logo */}
      <div className="flex items-center">
        <img
          src={logoAzul}
          alt="BravaForte"
          className="h-8 w-auto object-contain"
        />
      </div>

      {/* Notifications */}
      {showNotifications && (
        <div className="flex items-center">
          <NotificationDropdown />
        </div>
      )}
    </header>
  );
};

export default MobileHeader;
